import React from 'react'
import { useLocation } from 'react-router-dom'

import CreateSiteOrganizationBinding from '../../../../components/CreateSiteOrganizationBinding'
import ContextMenu from '../../../../components/ContextMenu'

export default function () {
  const query = new URLSearchParams(useLocation().search)
  const siteId = query.get('siteId')

  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Create a new site-organization binding</h1>}></ContextMenu>
      <CreateSiteOrganizationBinding siteId={siteId} />
    </div>
  )
}
